import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import PropTypes from 'prop-types';

export default function SelectedVehiclesList({ selectedVehicles, availableTankers }) {
  return (
    <List dense>
      {selectedVehicles.map((item) => {
        const color = Array.isArray(availableTankers)
          ? availableTankers.find((v) => v.registrationNum === item)?.color
          : undefined;
        return (
          <ListItem disablePadding key={item}>
            <ListItemIcon sx={{ minWidth: '30px' }}>
              <Box sx={{ backgroundColor: color, width: '15px', height: '15px' }} />
            </ListItemIcon>
            <ListItemText>{item}</ListItemText>
          </ListItem>
        );
      })}
    </List>
  );
}
SelectedVehiclesList.propTypes = {
  selectedVehicles: PropTypes.arrayOf(PropTypes.string).isRequired,
  availableTankers: PropTypes.arrayOf(
    PropTypes.shape({
      registrationNum: PropTypes.string,
      color: PropTypes.string,
    }),
  ),
};
SelectedVehiclesList.defaultProps = {
  availableTankers: [],
};
